import { useState, useEffect } from 'react'

const useImageLoader = (imageUrl) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageLoading, setImageLoading] = useState(true)
  const [loadedImageUrl, setLoadedImageUrl] = useState(null)

  useEffect(() => {
    if (!imageUrl) return

    const img = new Image()
    img.src = imageUrl

    img.onload = () => {
      setImageLoaded(true)
      setLoadedImageUrl(imageUrl)
      setImageLoading(false)
    }

    img.onerror = () => {
      setImageLoaded(false)
      setLoadedImageUrl(null)
      setImageLoading(false)
    }
  }, [imageUrl])

  return { url: loadedImageUrl, loading: imageLoading, loaded: imageLoaded }
}

export default useImageLoader
